import _ from 'lodash';
import swimmingManagement from './swimmingManagement';
import ticketManagement from './ticketManagement';
import orderManagement from './orderManagement';
import userManagement from './userManagement';

export default _.union(
  swimmingManagement,
  ticketManagement,
  orderManagement,
  userManagement,
  [{
    name: 'stadiumSuperviseSystem',
    path: '/stadiumSuperviseSystem',
    meta: { title: '场馆监管系统' },
    component: require('views/common/blank.vue').default
  }, {
    name: 'swimmingSuperviseStadium',
    path: '/stadiumSuperviseSystem/:stadiumType/swimmingSuperviseStadium',
    meta: { title: '游泳馆' },
    component: require('views/common/blank.vue').default
  }]
);
